import React from "react";
import BrandPageShell from "./BrandPageShell";
import "./LegalDocument.css";

export default function LegalDocument({ active, label, title, sections }) {
  return (
    <BrandPageShell active={active} pageClassName="legal-page">
      <header className="legal-hero">
        <div className="legal-container legal-hero-inner">
          <span className="legal-kicker">POLICIES / {label}</span>
          <h1>{title}</h1>
          <span className="legal-hero-index">PROFITGROWING / {label}</span>
        </div>
      </header>
      <div className="legal-container legal-layout">
        <aside className="legal-index">
          <span className="legal-index-heading">IN THIS DOCUMENT</span>
          <nav aria-label={title + " sections"}>
            {sections.map((section, index) => (
              <a key={section.id} href={"#" + section.id}>
                <span>{String(index + 1).padStart(2, "0")}</span>{section.title}
              </a>
            ))}
          </nav>
        </aside>
        <div className="legal-document">
          {sections.map((section, index) => (
            <article className="legal-article" id={section.id} key={section.id}>
              <div className="legal-article-meta"><span>{label} / SECTION</span><span>{String(index + 1).padStart(2, "0")}</span></div>
              <h2>{section.title}</h2>
              <p>{section.text}</p>
            </article>
          ))}
        </div>
      </div>
    </BrandPageShell>
  );
}
